module.exports = __webpack_public_path__ + "8b90e091a4eead342f6f1d5341e77751.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/browser/automations-onboarding.png
// module id = 5204
// module chunks = 25